import { Component, inject } from '@angular/core';
import { AuthService } from '@app/components/login.component';
import { PrimeNGButtonOpenItemViewActionComponent } from '@ntap/primeng';
import { map, mergeMap } from 'rxjs';

@Component({
  selector: 'app-edit-arhiv-posjednik',
  templateUrl: '../../../shared/components/actions/common-action-template.html'
})
export class EditArhivPosjednikComponent extends PrimeNGButtonOpenItemViewActionComponent {
  private authService = inject(AuthService);

  protected override initDisabledObservable(): void {
    this.isDisabled$ = this.itemProvider.item$.pipe(
      mergeMap((item) => {
        return this.authService.validUser$.pipe(
          map((user) => {
            const userHasRoles = AuthService.userHasAnyRole(user, [
              'Glavni administrator',
              'Glavni voditelj evidencije arhiva i posjednika gradiva u nadležnosti arhiva',
              'Voditelj evidencije posjednika',
              'Administrator arhiva'
            ]);

            const userHasMainRoles = AuthService.userHasAnyRole(user, [
              'Glavni administrator',
              'Glavni voditelj evidencije arhiva i posjednika gradiva u nadležnosti arhiva'
            ]);

            const hdaUuid = '5ee8fd64-7c93-47a5-810f-eea6a9217ff0';
            const arhivPosjednikNadlezniId = (item as any)[
              'en~arhiv_posjednik~nadlezni_arhiv'
            ];
            const arhivPosjednikId = (item as any)['en~arhiv_posjednik~id'];
            const arhivPosjednikUuid = (item as any)['en~arhiv_posjednik~uuid'];

            if (arhivPosjednikId == user.maticnaInstitucijaId) {
              return !userHasRoles;
            } else if (arhivPosjednikUuid != hdaUuid) {
              return !(
                userHasMainRoles ||
                (user.maticnaInstitucijaId == arhivPosjednikNadlezniId &&
                  userHasRoles)
              );
            }

            return true;
          })
        );
      })
    );
  }
}
